import { ReactNode } from "react";

interface EntityCardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export default function EntityCard({
  title,
  subtitle,
  actions,
  children,
}: EntityCardProps) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm">

      {(title || actions) && (
        <div className="flex items-start justify-between border-b border-slate-100 p-5">

          <div>

            {title && (
              <h2 className="text-lg font-semibold text-slate-900">
                {title}
              </h2>
            )}

            {subtitle && (
              <p className="mt-1 text-sm text-slate-500">
                {subtitle}
              </p>
            )}

          </div>

          {actions}

        </div>
      )}

      <div className="p-6">
        {children}
      </div>

    </div>
  );
}